module.exports = __webpack_public_path__ + "fonts/familyNew.26875b76.ttf";